export default __webpack_public_path__ + "static/media/ansu-fati.7f958cab.jpg";